
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  props: ["toggle"]
})
export default class HeaderMobile extends Vue {}
